<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script setup>
const { lang, xd_client_id, device_id, eventId, eventSessionId } = Object.fromEntries(
  new URLSearchParams(location.search),
);
lang && sessionStorage.setItem('query_lang', lang);
xd_client_id && sessionStorage.setItem('xd_client_id', xd_client_id);
device_id && sessionStorage.setItem('device_id', device_id);
if (eventId || eventSessionId) {
  sessionStorage.setItem('sls_eventSessionId', eventId || eventSessionId);
}
</script>

<style lang="less">
html,
body {
  margin: 0;
}
// #app {
//   font-family: Avenir, Helvetica, Arial, sans-serif;
//   -webkit-font-smoothing: antialiased;
//   -moz-osx-font-smoothing: grayscale;
//   color: #2c3e50;
//   height: 100vh;
//   width: 100vw;
// }
</style>
